import { packageVersion as alertUiVersion } from '@juvare/alert-ui';
import { announcementsVersion } from '@juvare/announcements';
import { badgingVersion } from '@juvare/badging';
import { commonFormUiVersion } from '@juvare/common-form-ui';
import { commonPhoneNumberVersion } from '@juvare/common-phone-number';
import { commonWebUiVersion } from '@juvare/common-web-ui';
import { contactManagementVersion } from '@juvare/contact-management';
import { credentialingVersion } from '@juvare/credentialing';
import { dataImportUiVersion } from '@juvare/data-import-ui';
import { documentLibraryVersion } from '@juvare/document-library';
import { missionsVersion } from '@juvare/missions';
import { packageVersion as platformAppVersion } from '@juvare/platform-app';
import { packageVersion as platformAppTestVersion } from '@juvare/platform-app-test';
import { platformCliVersion } from '@juvare/platform-cli';
import { packageVersion as platformSdkJsVersion } from '@juvare/platform-sdk-js';
import { packageVersion as platformSdkReactVersion } from '@juvare/platform-sdk-react';
import { packageVersion as platformSharedVersion } from '@juvare/platform-shared';
import { widgetUiVersion } from '@juvare/widget-ui';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const installedDependencies = [
    { name: '@juvare/rms', version: window.appVersion },
    { name: '@juvare/alert-ui', version: alertUiVersion },
    { name: '@juvare/announcements', version: announcementsVersion },
    // TODO: uncomment with CUI-646
    // { name: '@juvare/common-data-table-ui', version: commonDataTableUiVersion },
    { name: '@juvare/common-form-ui', version: commonFormUiVersion },
    { name: '@juvare/common-phone-number', version: commonPhoneNumberVersion },
    { name: '@juvare/common-web-ui', version: commonWebUiVersion },
    { name: '@juvare/contact-management', version: contactManagementVersion },
    { name: '@juvare/credentialing', version: credentialingVersion },
    { name: '@juvare/data-import-ui', version: dataImportUiVersion },
    { name: '@juvare/document-library', version: documentLibraryVersion },
    { name: '@juvare/missions', version: missionsVersion },
    { name: '@juvare/badging', version: badgingVersion },
    { name: '@juvare/platform-app', version: platformAppVersion },
    { name: '@juvare/platform-app-test', version: platformAppTestVersion },
    { name: '@juvare/platform-cli', version: platformCliVersion },
    { name: '@juvare/platform-sdk-js', version: platformSdkJsVersion },
    { name: '@juvare/platform-sdk-react', version: platformSdkReactVersion },
    { name: '@juvare/platform-shared', version: platformSharedVersion },
    { name: '@juvare/widget-ui', version: widgetUiVersion },
];

export const DependenciesVersionsTable: React.FC = () => {
    const { t } = useTranslation();
    const [alertUiServerVersion, setAlertUiServerVersion] = React.useState('');
    const [platformServerVersion, setPlatformServerVersion] = React.useState('');

    React.useEffect(() => {
        fetch('/platform/proxy/notify/alert/version')
            .then((response) => {
                if (response.ok) {
                    response
                        .text()
                        .then((version) => setAlertUiServerVersion(version))
                        .catch(console.error);
                }
            })
            .catch(console.error);
        fetch('/platform/api/v1/management/health')
            .then((response) => {
                if (response.ok) {
                    response
                        .json()
                        .then((json) => setPlatformServerVersion(json.version))
                        .catch(console.error);
                }
            })
            .catch(console.error);
    }, []);

    const allDependencies = [
        ...installedDependencies,
        { name: 'alert-service', version: alertUiServerVersion },
        { name: 'platform-server', version: platformServerVersion },
    ];

    return (
        <Table size='small'>
            <TableHead>
                <TableRow>
                    <TableCell>{t('appHeader.settings.moduleName')}</TableCell>
                    <TableCell>{t('appHeader.settings.version')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {allDependencies.map(({ name, version }) => (
                    <TableRow key={name}>
                        <TableCell>{name}</TableCell>
                        <TableCell>{version}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};
